export default __webpack_public_path__ + "static/media/comment-icon.bd271d69.svg";